import { NewsLetterProps } from "../types/NewsLetterProps";

export const newsletter: NewsLetterProps = {
    email: "",
};
